module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel05_1280_1280_ko-40c7b91efc06ca9d76433f9420878db4.jpg";